import axios from "axios";
import { toast } from "react-toastify";

import { signS3Attachment } from "../../api/SignS3";
import { alert } from "../common/Alert";

export async function submitAttachments({
  files,
  getValues,
  setPercentageUploaded,
  setCurrentFileName,
}) {
  const attachments = files ?? getValues?.()?.attachments;

  if (!attachments || attachments?.length === 0) {
    return;
  }

  alert("note-attachment", "Uploading attachments...");

  const uploadedFiles = [];

  for (const element of attachments) {
    const formData = new FormData();

    const fileType = element.name.split(".").pop();

    const signS3Response = await signS3Attachment(fileType, null);

    const { data, storageObjectName } = signS3Response.data;

    const { fields } = data;

    for (const key in fields) {
      formData.append(key, fields[key]);
    }

    formData.append("file", element);

    setCurrentFileName(element.name);
    setPercentageUploaded(0);

    await axios.post(data.url, formData, {
      headers: {
        "Access-Control-Allow-Origin": true,
      },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        setPercentageUploaded(percent);
      },
    });

    uploadedFiles.push({
      fileName: element.name,
      storageObjectName: storageObjectName,
      contentType: element.type,
    });
  }

  toast.dismiss("note-attachment");

  return uploadedFiles;
}

export function getFileExtensionType(fileName) {
  if (fileName) {
    return fileName.toLowerCase().split(".").pop();
  } else {
    return;
  }
}
